import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
       
<g transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M4480 7364 c-487 -729 -886 -1329 -888 -1334 -2 -6 658 -10 1800 -9
l1803 1 89 96 c50 54 122 131 160 172 156 167 346 372 346 374 0 1 -642 0
-1426 -1 -1380 -2 -1426 -2 -1421 16 2 10 300 460 661 1001 362 540 660 988
663 996 4 12 -65 14 -448 14 l-454 -1 -885 -1325z"/>
<path d="M3258 5503 c-146 -219 -268 -404 -272 -410 -6 -10 87 -13 447 -13
l455 0 271 405 c149 223 271 407 271 410 0 3 -204 5 -453 5 l-454 0 -265 -397z"/>
<path d="M3078 4195 c-95 -31 -158 -124 -142 -210 16 -88 83 -135 227 -159
115 -20 141 -33 145 -72 2 -25 -3 -37 -25 -54 -25 -19 -38 -21 -108 -18 -64 2
-92 9 -133 30 l-51 27 -36 -49 c-20 -28 -34 -54 -30 -60 10 -16 85 -52 140
-66 60 -16 185 -18 237 -4 140 39 202 198 115 297 -41 46 -90 68 -201 87 -106
19 -136 35 -136 76 0 45 38 65 125 64 51 0 81 -6 112 -22 23 -12 44 -22 47
-22 2 0 19 23 37 51 37 58 38 56 -51 90 -72 28 -206 35 -272 14z"/>
<path d="M4455 4197 c-63 -21 -101 -44 -141 -85 -48 -49 -71 -97 -83 -170 -27
-169 51 -318 196 -372 112 -42 280 -18 356 50 l30 27 -43 47 c-39 42 -45 45
-59 32 -53 -48 -173 -61 -241 -26 -109 56 -133 219 -47 317 17 20 46 42 64 49
63 27 166 11 213 -31 14 -13 21 -10 60 30 43 44 43 45 25 65 -10 11 -43 32
-73 47 -65 32 -191 41 -257 20z"/>
<path d="M5063 4191 c-77 -27 -136 -80 -175 -159 -30 -60 -33 -75 -32 -152 1
-112 27 -181 92 -242 130 -122 364 -122 494 0 136 127 125 385 -22 504 -82 65
-243 88 -357 49z m225 -132 c59 -29 92 -81 99 -157 7 -71 -8 -121 -49 -167
-34 -40 -80 -57 -149 -57 -101 1 -175 70 -186 174 -10 95 26 171 99 207 56 28
128 27 186 0z"/>
<path d="M7845 4197 c-68 -23 -101 -44 -148 -97 -63 -70 -80 -127 -75 -244 3
-77 8 -99 33 -145 62 -113 171 -167 324 -159 85 4 146 26 204 71 24 20 22 26
-24 73 l-41 42 -35 -24 c-65 -44 -175 -46 -237 -3 -107 73 -110 248 -6 331 61
48 165 50 233 4 l35 -24 43 44 c42 43 42 44 24 64 -10 11 -43 32 -73 47 -65
32 -191 41 -257 20z"/>
<path d="M2447 4168 c-8 -18 -71 -160 -141 -315 -69 -154 -126 -284 -126 -287
0 -4 34 -6 76 -4 l76 3 22 52 21 52 159 3 160 3 24 -57 25 -58 79 0 78 0 -13
33 c-8 17 -72 161 -142 320 l-128 287 -78 0 -79 0 -13 -32z m147 -245 c25 -62
46 -115 46 -118 0 -3 -45 -5 -100 -5 -62 0 -100 4 -100 10 0 23 94 240 101
233 4 -5 28 -58 53 -120z"/>
<path d="M3557 4193 c-4 -3 -7 -147 -7 -320 l0 -313 75 0 75 0 0 130 0 131
138 -3 137 -3 1 -125 0 -125 72 -3 72 -3 0 321 0 321 -71 -3 -71 -3 -2 -120
-1 -120 -137 -3 -138 -3 0 126 0 125 -68 0 c-38 0 -72 -3 -75 -7z"/>
<path d="M5640 3880 l0 -320 75 0 76 0 -1 188 c0 103 -1 191 0 197 0 5 23 -22
50 -60 28 -39 92 -127 143 -197 l92 -127 68 -1 67 0 0 320 0 321 -72 -3 -73
-3 0 -193 c0 -105 -3 -191 -7 -190 -4 2 -70 89 -146 193 l-138 190 -67 3 -67
3 0 -321z"/>
<path d="M6350 3880 l0 -320 70 0 70 0 2 197 3 198 54 -75 c30 -41 95 -130
144 -197 l90 -123 64 0 63 0 0 320 0 320 -70 0 -70 0 0 -196 c0 -107 -4 -193
-9 -190 -4 3 -70 91 -146 196 l-138 190 -63 0 -64 0 0 -320z"/>
<path d="M7057 4194 c-4 -4 -7 -148 -7 -321 l0 -313 250 0 250 0 0 60 0 60
-175 0 -175 0 0 70 0 70 160 0 160 0 0 60 0 60 -160 0 -160 0 0 55 c0 30 0 58
0 63 0 4 75 9 167 12 l168 5 0 60 0 60 -236 3 c-129 1 -238 -1 -242 -4z"/>
<path d="M8240 4135 l0 -65 95 0 95 0 2 -252 3 -253 73 -3 72 -3 0 256 0 255
100 0 101 0 -3 63 -3 62 -267 3 -268 2 0 -65z"/>
<path d="M2290 3015 l0 -205 104 0 c148 0 208 26 246 105 24 49 27 140 6 188
-17 43 -76 93 -123 106 -21 6 -82 11 -135 11 l-98 0 0 -205z m220 110 c69 -36
81 -153 21 -207 -27 -24 -40 -28 -91 -28 l-60 0 0 125 0 125 50 0 c28 0 64 -7
80 -15z"/>
<path d="M3347 3022 c-48 -108 -87 -200 -87 -204 0 -5 22 -8 49 -8 47 0 50 2
56 30 9 41 31 50 124 50 86 0 105 -9 117 -56 6 -21 12 -24 56 -24 60 0 64 -21
-45 226 l-81 184 -51 0 -50 0 -88 -198z m176 20 c15 -35 27 -68 27 -73 0 -6
-27 -9 -65 -8 -36 1 -65 6 -65 10 0 4 9 29 21 56 11 26 25 59 30 72 12 30 19
23 52 -57z"/>
<path d="M4280 3180 l0 -40 60 0 60 0 0 -165 0 -165 50 0 50 0 0 165 0 165 60
0 60 0 0 40 0 40 -170 0 -170 0 0 -40z"/>
<path d="M5360 3211 c0 -5 -38 -95 -85 -200 -47 -106 -85 -194 -85 -197 0 -2
22 -4 49 -4 43 0 50 3 55 24 12 47 31 56 117 56 92 0 113 -8 127 -50 10 -28
14 -30 61 -30 l50 0 -18 43 c-57 131 -131 297 -147 330 -17 36 -19 37 -71 37
-29 0 -53 -4 -53 -9z m93 -159 c15 -38 27 -73 27 -79 0 -7 -24 -11 -66 -11
-44 1 -64 4 -61 12 44 110 60 146 66 146 3 0 18 -31 34 -68z"/>
<path d="M6345 3206 c-65 -29 -93 -87 -70 -142 18 -44 48 -62 136 -80 76 -16
99 -27 99 -50 0 -45 -103 -60 -172 -25 l-36 18 -21 -28 c-12 -16 -21 -32 -21
-37 0 -21 99 -52 165 -52 111 0 175 44 175 120 0 68 -54 109 -165 125 -27 4
-56 12 -62 17 -19 16 -16 46 6 58 28 15 101 12 133 -4 26 -14 29 -13 48 14 11
15 20 31 20 35 0 3 -19 15 -42 25 -51 23 -148 26 -193 6z"/>
<path d="M7242 3066 c3 -171 8 -186 78 -233 39 -27 140 -32 193 -9 77 33 97
87 97 269 l0 128 -46 -3 -47 -3 2 -105 c2 -170 -20 -220 -98 -220 -27 0 -44 7
-62 26 -23 24 -24 33 -27 165 l-4 139 -45 0 -45 0 4 -154z"/>
<path d="M8270 3014 l0 -206 139 4 c153 3 180 13 210 73 17 35 1 97 -31 119
l-21 15 22 27 c25 32 28 90 5 123 -28 40 -73 51 -204 51 l-120 0 0 -206z m245
86 l0 -35 -77 -3 -78 -3 0 39 c0 21 2 41 4 43 2 2 37 2 78 -1 l73 -5 0 -35z
m1 -128 c19 -13 23 -39 8 -61 -13 -18 -25 -21 -90 -21 l-74 0 0 45 0 45 73 0
c39 0 77 -4 83 -8z"/>
</g>
</svg>









    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
